import { useMemo, useState } from 'react';

// Wiederverwendbare Spalten-Sortierung: Klick auf den Kopf sortiert,
// zweiter Klick dreht die Richtung. Zahlen numerisch, Strings per
// localeCompare, null/undefined immer ans Ende.
export function useTableSort(items, defaultKey = null, defaultDirection = 'desc') {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDirection, setSortDirection] = useState(defaultDirection);

  const requestSort = (key) => {
    if (sortKey === key) {
      setSortDirection((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDirection('desc');
    }
  };

  const sorted = useMemo(() => {
    if (!sortKey) return items;
    const getValue = (obj) =>
      sortKey.split('.').reduce((o, k) => (o == null ? o : o[k]), obj);
    return [...items].sort((a, b) => {
      let va = getValue(a);
      let vb = getValue(b);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === 'number' && typeof vb === 'number') {
        return sortDirection === 'asc' ? va - vb : vb - va;
      }
      const cmp = String(va).localeCompare(String(vb), 'de', { numeric: true, sensitivity: 'base' });
      return sortDirection === 'asc' ? cmp : -cmp;
    });
  }, [items, sortKey, sortDirection]);

  // Pfeil fürs Spalten-Label
  const indicator = (key) =>
    sortKey === key ? (sortDirection === 'asc' ? ' ↑' : ' ↓') : '';

  return { sorted, sortKey, sortDirection, requestSort, indicator };
}

export default useTableSort;
